import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iterable',
  standalone: false,
})
export class IterablePipe implements PipeTransform {
  /**
   * Converts a number into an array that mimics what a iteration over a number would behave like.
   * Example:  3 -> [0, 1, 2].
   *
   * @param value the value to convert.
   * @return the iterable representation of the number
   */
  transform(value: number, offset = 0): number[] {
    return Array(value)
      .fill(0)
      .map((x, i) => i + offset);
  }
}
